import React, { useEffect, useState } from 'react';
import PaymentTable from '../components/PaymentTable';
import AdminSidebar from '../components/AdminSidebar';
import AdminNavbar from '../components/AdminNavbar';
import { getPayments } from '../services/paymentService';
import { useSidebar } from '../components/SidebarContext';

const Payment = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isSidebarOpen } = useSidebar();
  const sidebarWidth = isSidebarOpen ? '250px' : '70px';

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const data = await getPayments();
        setPayments(data);
      } catch (error) {
        console.error('Error fetching payments:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPayments();
  }, []);

  // Inline styles (converted from Bootstrap)
  const pageStyle = {
    display: 'flex',
    minHeight: '100vh',
    background: 'linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF)', // Matches Dashboard
  };

  const mainContentStyle = {
    marginLeft: sidebarWidth,
    marginTop: '70px', // Matches AdminNavbar height
    flex: 1,
    padding: '24px',
    transition: 'margin-left 0.3s ease',
  };

  return (
    <div style={pageStyle}>
      {/* Sidebar */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100%',
          width: sidebarWidth,
          zIndex: 10,
          transition: 'width 0.3s ease',
        }}
      >
        <AdminSidebar />
      </div>

      {/* Main Content */}
      <div style={mainContentStyle}>
        {/* Navbar */}
        <AdminNavbar />

        {/* Page Body */}
        <div>
          <h1 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1F2937', marginBottom: '20px' }}>
            Student Payments
          </h1>
          {loading ? (
            <div style={{ textAlign: 'center' }}>
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  border: '4px solid #3b82f6', // Matches AdminLogin
                  borderTopColor: 'transparent',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                  margin: 'auto',
                }}
              />
            </div>
          ) : (
            <PaymentTable payments={payments} />
          )}
        </div>
      </div>
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default Payment;